import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { EXTEND_BUTTON, EXTEND_NOW_BUTTON } from '../../config/text/text';
import { symbolFromCurrency } from '../../helpers/currency';
import ThemeContext from '../../providers/ThemeProvider';
import PrimaryButton from '../_generic/button/PrimaryButton';

const ValidityDropDownItem = ({
  canBuyNow,
  extension,
  handleBuyButtonClick,
}) => {
  const theme = useContext(ThemeContext);
  const price = `${symbolFromCurrency(extension.extensionPrice.currency)}${
    extension.extensionPrice.amount
  }`;
  const buyButtonText = canBuyNow ? EXTEND_NOW_BUTTON : EXTEND_BUTTON;

  const handleButtonClick = () => {
    handleBuyButtonClick(extension);
  };

  return (
    <>
      <div className="item">
        <div className="item-line">
          <span className="title-col">
            <h4 className="title">{extension.voucherTitle}</h4>
            <p className="date">Extend until {extension.extensionDate}</p>
          </span>
          <span className="price-col">
            <p className="price">{price}</p>
            <p className="buy-button">
              <PrimaryButton
                className="size-small inline"
                id="extend-validity-button-buy"
                onClick={handleButtonClick}
              >
                {buyButtonText}
              </PrimaryButton>
            </p>
          </span>
        </div>
      </div>
      <style jsx>{`
        .item {
          border-bottom: 1px solid ${theme.commoncolors.greyshade};
          color: ${theme.commoncolors.greycharcoal};
          font-size: 13px;
          padding: 5px 0;
        }
        .item-line {
          align-items: center;
          display: flex;
        }
        .item:last-child {
          border-bottom: none;
        }
        .title-col {
          width: 65%;
        }
        .price-col {
          text-align: center;
          width: 35%;
        }
        .title {
          font-weight: normal;
          margin-bottom: 0;
          margin-right: 10px;
        }
        .date {
          color: ${theme.commoncolors.assure};
          font-weight: bold;
          margin-bottom: 0;
        }
        .price {
          font-weight: bold;
          font-size: 14px;
          margin-bottom: 0;
        }
        .buy-button {
          margin-top: 5px;
        }
      `}</style>
    </>
  );
};

export default ValidityDropDownItem;

ValidityDropDownItem.propTypes = {
  canBuyNow: PropTypes.bool,
  extension: PropTypes.object.isRequired,
  handleBuyButtonClick: PropTypes.func.isRequired,
};

ValidityDropDownItem.defaultProps = {
  canBuyNow: false,
};
